import React, { useEffect, useRef, useState } from 'react'
import './Bank.css'
import back from "../../imgs/backexam.png";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { UilEditAlt, UilTrash } from '@iconscout/react-unicons'
import { useTranslation } from "react-i18next";

const Bank = (props) => {
    const inputRefs = useRef([]);
    const [newedit, setNewedit] = useState("new");
    const [input, setInput] = useState({ bno: "", name: "", branch: "", ifsc: "" });
    const [DataSource, setDataSource] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [value, setValue] = useState('');
    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [sredit, setSredit] = useState('');

    const [t] = useTranslation();

    function handleEnterKey(event, currentIndex) {
        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = currentIndex + 1;
            if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
        }

        if (event.key === 'Backspace' && (
            (event.target.tagName === 'INPUT' && event.target.value === '') ||
            (event.target.tagName === 'SELECT' && (
                (event.target.name === 'type' && event.target.value === 'प्रकार निवडा')
            ))
        )) {
            event.preventDefault();
            let prevIndex = currentIndex - 1;
            while (prevIndex >= 0) {
                const prevElement = inputRefs.current[prevIndex];
                if (prevElement) {
                    if (
                        (prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') &&
                        prevElement !== event.target
                    ) {
                        prevElement.focus();
                        break;
                    } else prevIndex--;
                } else prevIndex--;
            }
        }
    }

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }));
    }

    // ✅ keep as-is (your code uses input.kno logic already)
    useEffect(() => {
        if (input.kno === "") {
            setInput(prevInput => ({
                ...prevInput,
                bno: "",
                name: "",
                branch: "",
                ifsc: "",
            }))
            setNewedit("new");
        }
    }, [input.kno])

    async function getmaxno() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => props.setProgress(50), 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getmaxnobank.php',
            { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }
        ).then(function sample(response) {

            if (response.data) {
                setInput(prevInput => ({
                    ...prevInput,
                    bno: parseInt(response.data) + 1
                }));
            } else {
                setInput(prevInput => ({
                    ...prevInput,
                    bno: 1
                }));
            }
        }).catch(err => {
            console.log(err);
        });
    }

    function handleEnterKeybutton(event, currentIndex) {
        if (event.key === 'Enter') {
            event.preventDefault();
            savebank();
            let nextIndex = currentIndex + 1;
            if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
        }
        else if (event.key === "Backspace") {
            if (event.target.tagName === "BUTTON") {
                if (inputRefs.current[4]) inputRefs.current[4].focus();
            }
        }
    }

    const savebank = () => {
        var mainuser2 = jsEncode.encode("mamapr", 125);

        if (input.bno === "" || input.name === "" || input.branch === "" || (input.ifsc === "")) {
            notifyerror(t("bank.toast.incomplete_entry"));
            return;
        }

        let rawData = {
            bno: input.bno,
            name: input.name,
            branch: input.branch,
            ifsc: input.ifsc,
            flag: newedit,
            sredit: sredit,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
        }

        rawData = JSON.stringify(rawData);
        let formData = new FormData();

        if (newedit === "edit") formData.append('data', rawData);
        else if (newedit === "new") formData.append('data', rawData);

        axios.post('https://excellentdairy.com/dairy/php/cust/savebank.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {

            if (newedit === "new") {
                if (response.data.trim() === "Saved.") {
                    // ✅ only UI message translated (kept your weird suffix "sdf" removed? -> kept same meaning)
                    notify(t("bank.toast.saved"));
                    setInput(prevInput => ({
                        ...prevInput,
                        bno: parseInt(input.bno) + 1,
                        name: "",
                        branch: "",
                        ifsc: "",
                    }))
                    setSredit("");
                    setNewedit("new");
                    getbank();
                    if (inputRefs.current[0]) inputRefs.current[0].focus();
                }
            } else {
                if (response.data.trim() === "updated.") {
                    notify(t("bank.toast.updated"));
                    getbank();
                }
            }
        }).catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        getmaxno();
        getbank();
        if (inputRefs.current[0]) inputRefs.current[0].focus();
    }, [])

    async function getbank() {
        var mainuser2 = jsEncode.encode("mamapr", 125);

        axios.post('https://excellentdairy.com/dairy/php/cust/getbank.php',
            { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }
        ).then(function sample(response) {

            if (response.data) {
                setDataSource(response.data);
                setTimeout(() => props.setProgress(100), 200);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const handleedit = (bno, bname, branch, ifsc) => {
        setInput({ bno: bno, name: bname, branch: branch, ifsc: ifsc })
        setNewedit("edit");
        setSredit(bno);
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                var a = str.charCodeAt(i);
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    return (
        <div className="khadyamain">
            <div className="firstrowkhadya">
                <img onClick={props.visibility} className='back' src={back} alt="" />
                <div className="colmainkhadya">
                    <div className="firstrow2">
                        <div className="rowsank">
                            <div className="mb-2">
                                <span className='subheadsank'>{t("bank.labels.bank_no")}</span>
                                <input
                                    disabled
                                    onKeyDown={e => handleEnterKey(e, 1)}
                                    ref={ref => (inputRefs.current[1] = ref)}
                                    type="number"
                                    className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
                                    autoComplete='off'
                                    id="bno"
                                    name="bno"
                                    value={input.bno}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='linekh' />

            <div className="row1sangh" />

            <div className="row1sangh">
                <div className="mb-2">
                    <span className='subheadsank'>{t("bank.labels.bank_name")}</span>
                    <input
                        type="text"
                        onKeyDown={e => handleEnterKey(e, 0)}
                        ref={ref => (inputRefs.current[0] = ref)}
                        className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                        autoComplete='off'
                        id="name"
                        name="name"
                        value={input.name}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-2">
                    <span className='subheadsank'>{t("bank.labels.branch")}</span>
                    <input
                        type="text"
                        onKeyDown={e => handleEnterKey(e, 1)}
                        ref={ref => (inputRefs.current[1] = ref)}
                        className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                        autoComplete='off'
                        id="branch"
                        name="branch"
                        value={input.branch}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-2">
                    <span className='subheadsank'>{t("bank.labels.ifsc")}</span>
                    <input
                        onKeyDown={e => handleEnterKey(e, 2)}
                        ref={ref => (inputRefs.current[2] = ref)}
                        className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
                        autoComplete='off'
                        id="ifsc"
                        name="ifsc"
                        value={input.ifsc}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className='linekh' />

            <div className="row1sangh">
                <div className="mb-2">
                    <button
                        onClick={savebank}
                        onKeyDown={e => handleEnterKeybutton(e, 0)}
                        ref={ref => (inputRefs.current[3] = ref)}
                        type="submit"
                        className="btn btn-primary mx-1 sanksmall"
                    >
                        {newedit === "new" ? t("common.save") : t("common.update")}
                    </button>

                
                </div>
            </div>

            <div className="firstrow2">
                <div className="table-containeruchal">
                    <table id="myTable" className="table table-bordered">
                        <thead>
                            <tr>
                                <th className='thsmall' scope="col">{t("bank.table.bank_no")}</th>
                                <th className='thsmall' scope="col">{t("bank.table.name")}</th>
                                <th className='thsmall' scope="col">{t("bank.table.branch")}</th>
                                <th className='thsmall' scope="col">{t("bank.table.ifsc")}</th>
                                <th className='thsmall' scope="col">{t("bank.table.action")}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {(value.length > 0 ? tableFilter : DataSource).map((user, index) =>
                                <tr key={index}>
                                    <td className='thsmallaudit'>{user.bno}</td>
                                    <td className='thsmallaudit'>{user.bname}</td>
                                    <td className='thsmallaudit'>{user.branch}</td>
                                    <td className='thsmallaudit'>{user.ifsc}</td>
                                    <td>
                                        <UilEditAlt
                                            onClick={() => { handleedit(user.bno, user.bname, user.branch, user.ifsc) }}
                                            className="icsank"
                                        />
                                        <UilTrash className="icsank" />
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </div>

            <ToastContainer />
        </div>
    )
}

export default Bank;
